<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.serial_num">
    <app-popup-header title="{{localService.languageContent.serial_num.bulk_option}}"></app-popup-header>
    <div class="box">
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.serial_num.bulk_upload_file"
                    [isWrap]="true"></app-label>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <button class="btn btn-primary" style="width: 100%;"
                    title="{{localService.languageContent.serial_num.bulk_template}}"
                    (click)="onAction(1)">{{localService.languageContent.serial_num.bulk_template}}</button>
            </div>
            <div class="col-6">
                <button class="btn btn-primary" style="width: calc(100% - 40px);"
                    title="{{localService.languageContent.serial_num.bulk_upload}}"
                    (click)="onAction(2)">{{localService.languageContent.serial_num.bulk_upload}}</button>
                <app-file-upload class="icon_adjust_prod_header" [Id]="elementIds.file"
                    style="top: 7px;margin-left: 5px;position: relative;" [fileUploadFor]="FileUploadFor.ProductSerialNumber" [forId]="productId"
                    [ctryCode]="ctryCode" (onFileUploaded)="onAction(3)"
                    [forId3]="purchaseEntryDetailId"></app-file-upload>
            </div>
        </div>
    </div>
    <div class="box">
        <div class="row">
            <div class="col-12">
                <app-label [Text]="localService.languageContent.serial_num.bulk_upload_auto"></app-label>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-list-options *ngIf="selectedType != ''" [items]="productSerialNumberTypes"
                    [selectedKey]="selectedType" (onSelectionChanged)="onSelectionChanged($event)"
                    [isBannerType]="false"></app-list-options>
            </div>
        </div>
        <div class="row">
            <div class="col-md-7">
                <label style="margin-left:35px;margin-top: 10px; font-weight:normal;">
                    <input type="checkbox" [(ngModel)]="isExpiryAllowed">
                    <span
                        style="color:darkslategrey">&nbsp;{{localService.languageContent.serial_num.is_exp_allow}}</span>
                </label>
                <span class="en">&nbsp;:&nbsp;</span>
            </div>
            <div class="col-md-5">
                <app-date-picker style="left: 40px;position: relative;" [isDisabled]="!isExpiryAllowed"
                    [selectedDate]="selectedDate" (selectedDateChange)="selectedDate = $event"
                    (isOpenChange)="showHideDummyHeight($event)"></app-date-picker>
                <div *ngIf="isShowDummyHeight"
                    [ngStyle]="{'height' : localService.getHeightOfOpenedControls('2,6') + 'px'}">
                    &nbsp;
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <input type="text" [(ngModel)]="prefix" maxlength="20" (input)="onSerialEnter($event)"
                    placeholder="{{localService.languageContent.serial_num.prefix}}"
                    title="{{localService.languageContent.serial_num.prefix}}" />
            </div>
            <div class="col-md-6">
                <input type="text" [(ngModel)]="suffix" maxlength="20" (input)="onSerialEnter($event)"
                    placeholder="{{localService.languageContent.serial_num.suffix}}"
                    title="{{localService.languageContent.serial_num.suffix}}" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <input autocomplete="off" type="number" class="number" id="{{elementIds.max_cnt}}"
                    [ngClass]="maximumCount ? 'en' : ''" (keypress)="localService.isNumberOnly($event,numericConfig)"
                    [(ngModel)]="maximumCount" placeholder="*{{localService.languageContent.serial_num.max_cnt}}"
                    title="*{{localService.languageContent.serial_num.max_cnt}}" />
            </div>
            <div class="col-md-6">
                <app-label [Text]="localService.languageContent.serial_num.sample"></app-label>
                <span>&nbsp;{{prefix | uppercase }}{{selectedType == '1' ? '73216798' : '7IBNSP96F'}}{{suffix |
                    uppercase}}</span>
            </div>
        </div>
        <div class="row" *ngIf="message != ''">
            <div class="col-12" style="text-align: center;">
                <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
        </div>
        <div class="row">
            <div class="col-12" style="text-align: right;">
                <button type="button" class="btn btn-primary"
                    (click)="onSave()">{{localService.languageContent.common.create}}</button>
            </div>
        </div>
    </div>
</div>